<div class="raptor-prgress bg-primary" [style]="'width: ' + width"></div>
